import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'

import './RenderProduct.css'

const RenderProduct = (props) => (
  <div className="product" key={props.product.fields.title}>
    <h4>{props.product.fields.title} {(!props.hidePrice && !props.product.fields.specialFormatPrice && props.product.fields.price) && <span>{props.product.fields.price.toFixed(2).replace('.',',').replace(',00', ':-')}</span>}
    {(!props.hidePrice && props.product.fields.specialFormatPrice) && <span>{props.product.fields.specialFormatPrice.replace('.',',')}</span>}</h4>
    {props.product.fields.description && <ReactMarkdown source={props.product.fields.description} softBreak="br" />}
  </div>
)

RenderProduct.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(RenderProduct);



// WEBPACK FOOTER //
// ./src/components/RenderProduct.js